import React from 'react'
import { AppState } from '../../reducers/index'
import { Alert as MuiAlert, Snackbar } from '@mui/material'
import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material'
import { connect, useDispatch } from 'react-redux';
import { hideAlert } from '../../actions/alert';

/*
const Alert: React.FC<StateProps> = ({ message, isError = false }) => {
  const dispatch = useDispatch()

  return (
    <Snackbar
      open={!!message}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={6000}
      onClose={() => { dispatch(hideAlert) }}
    >
      <div>
        {isError ? <ErrorOutline /> : <CheckCircleOutline/>}&nbsp;
        {message}
      </div>
    </Snackbar >
  )
}
*/

const Alert: React.FC<StateProps> = ({ message, isError = false }) => {
  const dispatch = useDispatch()

  return (
    <Snackbar
      open={!!message}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={6000}
      onClose={() => { dispatch(hideAlert) }}
    >
      <MuiAlert
        onClose={() => { dispatch(hideAlert) }}
        severity={isError ? "error" : "success"}
        icon={isError ? <ErrorOutline /> : <CheckCircleOutline/>}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </MuiAlert>
    </Snackbar >
  )
}



type StateProps = ReturnType<typeof mapStateToProps>
const mapStateToProps = ({ alert }: AppState) => alert

export default connect(mapStateToProps, null)(Alert)